import { ReminderView } from "../types/reminderTypes";
import {
  filterByNameAndLBO,
  filterArticlesByName,
  filterAggregatedByName,
} from "../utils/filterUtils";
import { getTypeSafeSearchFunction } from "../utils/searchTypes";

export interface UnifiedViewConfig {
  search: {
    enabled: boolean;
    placeholder: string;
    searchType: "patient-dual" | "article-patient-dual" | "article-only";
    searchFunction: (search: string, data: any[]) => any[];
    searchFields: string[];
    description: string;
  };
  filters: {
    dateRange: boolean;
    groups: boolean;
    therapyTaken: boolean;
    status: boolean;
  };
}

export const UNIFIED_VIEW_CONFIG: Record<ReminderView, UnifiedViewConfig> = {
  [ReminderView.PATIENTS]: {
    search: {
      enabled: true,
      placeholder: "Pretraži po imenu ili LBO",
      searchType: "patient-dual",
      searchFunction: filterByNameAndLBO,
      searchFields: ["userFirstName", "userSecondName", "userLBO", "note"],
      description: "Search patient data by name or LBO",
    },
    filters: {
      dateRange: true,
      groups: true,
      therapyTaken: true,
      status: true,
    },
  },
  [ReminderView.ARTICLES]: {
    search: {
      enabled: true,
      placeholder: "Pretraži po nazivu artikla ili imenu pacijenta",
      searchType: "article-patient-dual",
      searchFunction: filterArticlesByName,
      searchFields: ["articleName", "patientName", "patientLBO", "note"],
      description:
        "Search both article names and patient information (DUAL SEARCH)",
    },
    filters: {
      dateRange: true,
      groups: true,
      therapyTaken: true,
      status: true,
    },
  },
  [ReminderView.AGGREGATED]: {
    search: {
      enabled: true,
      placeholder: "Pretraži po nazivu artikla",
      searchType: "article-only",
      searchFunction: filterAggregatedByName,
      searchFields: ["articleName"],
      description: "Search aggregated data by article name only",
    },
    filters: {
      dateRange: true,
      groups: false, // Backend limitation
      therapyTaken: false, // Backend limitation
      status: false, // Backend limitation
    },
  },
};

// Helper functions for easy access
export const getViewConfig = (view: ReminderView): UnifiedViewConfig => {
  return UNIFIED_VIEW_CONFIG[view];
};

export const getSearchConfig = (view: ReminderView) => {
  return UNIFIED_VIEW_CONFIG[view].search;
};

export const getFilterConfig = (view: ReminderView) => {
  return UNIFIED_VIEW_CONFIG[view].filters;
};

// Type-safe helper to get search function
export const getSearchFunction = (view: ReminderView) => {
  return getTypeSafeSearchFunction(view);
};
